import { Settings } from '../components/Settings'

/**
 * 設定ページ
 */
export function SettingsPage() {
  return <Settings />
}
